export class ProgramStatementsModel {
    
    // EQOPPORTUNITYERSTATEMENT
    public eqOpportunityErStatement: string;
    //DEBITCARDFEEACNOWLEDGEMENT
    public debitCardFeeAcknowledgement : string;
    // LOGINSTATEMENTBEFORE
    public loginStatementBefore: string;
    // LOGINSTATEMENTAFTER
    public loginStatementAfter: string;
    // LOGINSTATEMENTAPPCUTOFFMSG
    public loginStatementAppCutoffMsg: string;
    public submissionMsg: string;
    public thankYouMsg: string;
    public fileUploadMsg: string;
    public paymentMethodSelectMsg: string;
    public isLoginHidden:boolean;

    public isRegisterHidden:boolean;

    public isReferralCodeRequired:boolean;

    public isRestricted: boolean;

    constructor(eqOpportunityErStatement:string,loginStatementBefore:string,
        loginStatementAfter:string,loginStatementAppCutoffMsg:string,thankYouMsg : string, 
        subMsg : string, fileUploadMsg: string, paymentMethodSelectMsg: string, debCardFeedBack:string, 
        isLoginHidden?:boolean, isRegisterHidden?:boolean,isReferralCodeRequired?:boolean, 
        isRestricted?: boolean ){
            this.eqOpportunityErStatement=eqOpportunityErStatement;
            this.loginStatementAfter=loginStatementAfter;
            this.loginStatementBefore=loginStatementBefore;
            this.loginStatementAppCutoffMsg=loginStatementAppCutoffMsg;
            this.isLoginHidden=isLoginHidden;
            this.isRegisterHidden=isRegisterHidden;
            this.isReferralCodeRequired=isReferralCodeRequired;
            this.debitCardFeeAcknowledgement=debCardFeedBack;
            this.isRestricted=isRestricted;
            this.submissionMsg = subMsg;
            this.fileUploadMsg = fileUploadMsg;
            this.thankYouMsg = thankYouMsg;
            this.paymentMethodSelectMsg = paymentMethodSelectMsg;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/program-statements.model.ts